'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { LogIn } from 'lucide-react';
interface LoginPromptProps {
  onLogin: () => void;
}
function LoginPrompt(t0) {
  const $ = _c(5);
  const {
    onLogin
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-primary/10 flex size-12 items-center justify-center rounded-full"><LogIn className="text-primary size-6" aria-hidden="true" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-1.5"><h3 className="text-foreground text-base font-semibold lg:text-lg">Log in to continue</h3><p className="text-muted-foreground text-sm">Please log in to continue with your service purchase.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LogIn className="size-4" aria-hidden="true" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onLogin) {
    t4 = <Card className="mx-auto w-full max-w-218.5 border-none py-0! lg:mx-0 lg:max-w-none"><CardContent className="flex flex-col items-center gap-4 p-6 text-center lg:p-8">{t1}{t2}<Button onClick={onLogin} className="w-full">{t3}Log in</Button></CardContent></Card>;
    $[3] = onLogin;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export { LoginPrompt };